import React from 'react';

interface SheetSelectModalProps {
  sheets: string[];
  onSelect: (sheet: string) => void;
  onCancel: () => void;
}

const SheetSelectModal: React.FC<SheetSelectModalProps> = ({ sheets, onSelect, onCancel }) => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
      <div className="bg-base-100 rounded-lg shadow-lg p-8 min-w-[320px]">
        <h2 className="text-lg font-bold mb-4 text-base-content">Select a Sheet</h2>
        <div className="space-y-3 mb-6">
          {sheets.map(sheet => (
            <button
              key={sheet}
              className="btn btn-primary w-full"
              onClick={() => onSelect(sheet)}
            >
              {sheet}
            </button>
          ))}
        </div>
        <button className="btn btn-ghost w-full" onClick={onCancel}>Cancel</button>
      </div>
    </div>
  );
};

export default SheetSelectModal;
